// KioskModeContext.js
import React, { createContext, useState } from 'react';

const KioskModeContext = createContext();

const KioskModeProvider = ({ children }) => {
  const [isKioskMode, setIsKioskMode] = useState(false);
  const [isModelOpen,setIsModelOpen]=useState(false);

  return (
    <KioskModeContext.Provider value={{ isKioskMode, setIsKioskMode, isModelOpen,setIsModelOpen}}>
      {children}
    </KioskModeContext.Provider>
  );
};

export { KioskModeProvider, KioskModeContext };